$mol_view_tree2_to_js_test_ex_array_with_types_foo $mol_object
	arr /readonly(number)[]
